/* =========================================================
   SF — deck-tabs.js (assets-safe, NO Liquid)
   Ported 1:1 behavior, but bound to product-recommendations DOM.

   - Canvas/Journals: hard-limit bubbles to 3, bubble->hero swap, bubble#1 sync to hero
   - Waves: --wavesY parallax on .slide-container
   - Shirts: auto-rotate color groups, hero crossfade, bubble crossfade, bubble click selects view

   Mount-safe:
   - Call window.SFDeckTabsInit(root) after AJAX inject (recommendations).
   ========================================================= */
(function () {
  'use strict';

  // ------------------------------------------------------------
  // Helpers
  // ------------------------------------------------------------
  function isEl(n) { return !!(n && n.nodeType === 1); }
  function $all(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // ------------------------------------------------------------
  // (A) Canvas/Journals bubble->hero (your Bubble images W3 script)
  // ------------------------------------------------------------
  function initCanvasJournalsBubbles(SCOPE) {
    if (!SCOPE || !SCOPE.querySelectorAll) return;
    if (SCOPE.dataset.dtCJBubblesInit === '1') return;
    SCOPE.dataset.dtCJBubblesInit = '1';

    function normalizeUrl(u) {
      if (!u) return '';
      try {
        var url = new URL(u, window.location.href);
        return url.pathname.replace(/_(\d+x\d+)\./, '.');
      } catch (e) {
        return (u.split('?')[0] || '').replace(/_(\d+x\d+)\./, '.');
      }
    }

    function imgKey(img) {
      return normalizeUrl((img && (img.currentSrc || img.getAttribute('src') || '')) || '');
    }

    function readAttrs(img) {
      var attrs = ['src','srcset','sizes','data-src','data-srcset','data-sizes','alt'];
      var out = {};
      attrs.forEach(function(name){ out[name] = img.getAttribute(name); });
      return out;
    }

    function applyAttrs(img, attrs) {
      Object.keys(attrs).forEach(function(name){
        var val = attrs[name];
        if (val === null || typeof val === 'undefined') img.removeAttribute(name);
        else img.setAttribute(name, val);
      });
    }

    function setHeroFromPod(heroImg, podImg) {
      if (!heroImg || !podImg || heroImg === podImg) return;
      applyAttrs(heroImg, readAttrs(podImg)); // copy only (NO swap)
    }

    function findHeroForCard(card) {
      return (
        card.querySelector('#top-left .canvas-img-wrapper img') ||
        card.querySelector('#top-left img') ||
        card.querySelector('.top-left .canvas-img-wrapper img') ||
        card.querySelector('.top-left img') ||
        card.querySelector('.listing-top img')
      );
    }

    function setActivePod(card, podWrapper) {
      card.querySelectorAll('.right-container .inner-img.is-active')
        .forEach(function(node){ node.classList.remove('is-active'); });
      if (podWrapper) podWrapper.classList.add('is-active');
    }

    function blurActiveElementSoon() {
      requestAnimationFrame(function(){
        var ae = document.activeElement;
        if (ae && typeof ae.blur === 'function') ae.blur();
      });
    }

    // ✅ bubble #1 matches hero
    function syncFirstThreeBubblesToHero(card) {
      var heroImg = findHeroForCard(card);
      if (!heroImg) return;

      var podImgs = Array.from(card.querySelectorAll('.right-container .inner-img img')).slice(0,3);
      if (!podImgs.length) return;

      var heroK = imgKey(heroImg);
      var podKs = podImgs.map(imgKey);

      var attrs = podImgs.map(readAttrs);
      var newAttrs;

      var idx = heroK ? podKs.indexOf(heroK) : -1;

      if (idx === 0) {
        newAttrs = attrs;
      } else if (idx > 0) {
        newAttrs = [attrs[idx]].concat(attrs.slice(0, idx), attrs.slice(idx+1));
      } else {
        newAttrs = [readAttrs(heroImg)].concat(attrs.slice(0, 2));
      }

      newAttrs.forEach(function(a, i){
        if (podImgs[i]) applyAttrs(podImgs[i], a);
      });

      var wrappers = Array.from(card.querySelectorAll('.right-container .inner-img')).slice(0,3);
      setActivePod(card, wrappers[0] || null);
    }

    // ONLY canvas/journal cards
    var cards = $all(SCOPE, '.slide-item.is-canvas, .slide-item.is-journal');

    // Hard-limit to 3 bubbles per card
    cards.forEach(function(card){
      var pods = card.querySelectorAll('.right-container .right-inner');
      for (var i = 3; i < pods.length; i++) pods[i].remove();
    });

    // Sync bubbles to hero
    cards.forEach(syncFirstThreeBubblesToHero);

    // Click bubble -> hero swap + highlight
    SCOPE.addEventListener('click', function(event){
      var podWrapper = event.target.closest('.inner-img');
      if (!podWrapper || !SCOPE.contains(podWrapper)) return;

      var card = podWrapper.closest('.slide-item.is-canvas, .slide-item.is-journal');
      if (!card || !SCOPE.contains(card)) return;

      // only first 3 bubbles
      var allowed = Array.from(card.querySelectorAll('.right-container .inner-img')).slice(0,3);
      if (allowed.indexOf(podWrapper) === -1) return;

      var podImg  = podWrapper.querySelector('img');
      var heroImg = findHeroForCard(card);
      if (!podImg || !heroImg) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      setActivePod(card, podWrapper);
      setHeroFromPod(heroImg, podImg);
      blurActiveElementSoon();
    }, true);
  }

  // ------------------------------------------------------------
  // (B) Waves watermark parallax (your 2nd script; NO Liquid)
  // ------------------------------------------------------------
  var WAVES = { inited:false, nodes:new Set(), ticking:false };

  function initWavesParallax(SCOPE) {
    if (!SCOPE || !SCOPE.querySelectorAll) return;

    $all(SCOPE, '.slide-container').forEach(function(c){
      if (c.dataset.dtWavesInit === '1') return;
      c.dataset.dtWavesInit = '1';
      WAVES.nodes.add(c);
    });

    if (WAVES.inited) return;
    WAVES.inited = true;

    function update(){
      WAVES.ticking = false;
      var y = window.scrollY * -0.06;
      WAVES.nodes.forEach(function(c){
        if (!c.isConnected) { WAVES.nodes.delete(c); return; }
        c.style.setProperty('--wavesY', y.toFixed(2) + 'px');
      });
    }

    function onScroll(){
      if (WAVES.ticking) return;
      WAVES.ticking = true;
      requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll, { passive:true });
  }



  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------
  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------
 /* =========================
   DESKTOP ONLY HERO PATCH
   - Use !important for transition/opacity ONLY at >= 990px
   - Mobile remains untouched
   ========================= */
function isDesktop990(){
  return window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
}

function setStyle(el, prop, val){
  if (!el) return;
  if (isDesktop990()) el.style.setProperty(prop, val, 'important');
  else el.style[prop] = val;
}
 
  
  
  var INTERVAL_MS = 3600;
  var PAUSE_AFTER_TOUCH_MS = 2800;

  var HERO_FADE_MS = 1200;
  var HERO_LAYER_OUT_MS = 180;

  var BUBBLE_FADE_MS = 1200;
  var BUBBLE_LAYER_OUT_MS = 180;

  var BUBBLE_SWAP_DELAY_MS = 0;

  var productGroupsCache = new Map();
  var preloadCache = new Map();

  function normalizeUrl(u){
    if (!u) return '';
    try { u = (new URL(u, window.location.href)).toString(); } catch(e){}
    return (u.split('?')[0] || '').replace(/_(\d+x\d+|\d+x|\d+)\./, '.');
  }

  function pickFirstFromSrcset(srcset){
    if (!srcset) return '';
    var first = (srcset.split(',')[0] || '').trim();
    return (first.split(' ')[0] || '').trim();
  }

  function bestUrlFromAttrs(attrs){
    if (!attrs) return '';
    return (
      attrs.src ||
      attrs["data-src"] ||
      pickFirstFromSrcset(attrs.srcset) ||
      pickFirstFromSrcset(attrs["data-srcset"]) ||
      ''
    );
  }

  function makeUrlAttrs(url, alt){
    return {
      src: url || null,
      srcset: null,
      sizes: null,
      "data-src": null,
      "data-srcset": null,
      "data-sizes": null,
      alt: alt || ""
    };
  }

// =========================================================
// SF — Width clamp helpers (Recommendations / Shirts)
// Purpose:
//  - Force bubble thumbs to request tiny assets
//  - Force hero swaps to request reasonable mid-size assets
//  - Strip any legacy _800x / _1100x suffix before adding ?width=
// =========================================================
var HERO_W   = 720;  // hero swap width (recommendations)
var BUBBLE_W = 120;  // bubble thumb width (56px UI)

function withShopifyWidth(url, w){
  url = normalizeUrl(url); // IMPORTANT: removes _800x style suffixes
  if (!url) return '';
  try{
    var u = new URL(url, window.location.href);
    u.searchParams.set('width', String(w));
    return u.toString();
  }catch(e){
    if (/([?&])width=\d+/.test(url)) {
      return url.replace(/([?&])width=\d+/, '$1width=' + w);
    }
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
}

function heroAttrsFrom(viewAttrs, fallbackAlt){
  var base = bestUrlFromAttrs(viewAttrs);
  var u = withShopifyWidth(base, HERO_W);
  return makeUrlAttrs(u, (viewAttrs && viewAttrs.alt) || fallbackAlt || '');
}

function bubbleAttrsFrom(viewAttrs, fallbackAlt){
  var base = bestUrlFromAttrs(viewAttrs);
  var u = withShopifyWidth(base, BUBBLE_W);
  return makeUrlAttrs(u, (viewAttrs && viewAttrs.alt) || fallbackAlt || '');
}


  function readAttrs(img){
    var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
    var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || null;
    var sizes = img.getAttribute('sizes') || img.getAttribute('data-sizes') || null;

    return {
      src: src || null,
      srcset: srcset,
      sizes: sizes,
      "data-src": img.getAttribute('data-src'),
      "data-srcset": img.getAttribute('data-srcset'),
      "data-sizes": img.getAttribute('data-sizes'),
      alt: img.getAttribute('alt')
    };
  }

  function applyAttrs(img, attrs){
    for (var k in attrs){
      if (!Object.prototype.hasOwnProperty.call(attrs,k)) continue;
      var v = attrs[k];
      if (v === null || typeof v === 'undefined') img.removeAttribute(k);
      else img.setAttribute(k, v);
    }
  }

  function preloadDecode(url){
    url = url || '';
    if (!url) return Promise.resolve();

    var key = normalizeUrl(url);
    if (preloadCache.has(key)) return preloadCache.get(key);

    var p = new Promise(function(resolve){
      var im = new Image();
      im.decoding = 'async';
      im.loading = 'eager';
      im.src = url;

      var done = false;
      function finish(){ if (done) return; done = true; resolve(); }

      if (im.decode) im.decode().then(finish).catch(finish);
      im.onload = finish;
      im.onerror = finish;

      setTimeout(finish, 2000);
    });

    preloadCache.set(key, p);
    return p;
  }

  function chunkBy4(arr){
    var out = [];
    for (var i=0; i+3 < arr.length; i += 4){
      out.push([arr[i], arr[i+1], arr[i+2], arr[i+3]]);
    }
    return out;
  }

  function findHeroImg(card){
    return (
      card.querySelector('#top-left img.dt-hero-base') ||
      card.querySelector('#top-left img:not(.dt-hero-xfade)') ||
      card.querySelector('.top-left img.dt-hero-base') ||
      card.querySelector('.top-left img:not(.dt-hero-xfade)') ||
      card.querySelector('.listing-top img.dt-hero-base') ||
      card.querySelector('.listing-top img:not(.dt-hero-xfade)')
    );
  }

  function first3Wrappers(card){
    return Array.prototype.slice.call(card.querySelectorAll('.right-container .inner-img'), 0, 3);
  }

  function setActiveView(card, wrappers, idx){
    for (var i=0;i<wrappers.length;i++) wrappers[i].classList.remove('is-active');
    if (wrappers[idx]) wrappers[idx].classList.add('is-active');
  }

  function ensureHeroStage(card){
  var base = findHeroImg(card);
  if (!base) return null;

  if (base.__dtHeroReady) {
    return { base: base, xfade: base.__dtHeroXfade, stage: base.__dtHeroStage };
  }

  var topLeft = base.closest('#top-left') || base.closest('.top-left') || base.parentElement;
  if (!topLeft) return null;

  var stage = document.createElement('div');
  stage.className = 'dt-hero-stage';

  // Minimal hardening: ensure overlay can stack correctly on desktop themes
  stage.style.position = stage.style.position || 'relative';

  base.parentNode.insertBefore(stage, base);
  stage.appendChild(base);

  base.classList.add('dt-hero-base');

  var xfade = document.createElement('img');
  xfade.className = 'dt-hero-xfade';
  xfade.alt = base.getAttribute('alt') || '';
  xfade.decoding = 'async';
  xfade.loading = 'eager';

  // Minimal hardening: make overlay actually overlay (some desktop CSS breaks this)
  xfade.style.position = 'absolute';
  xfade.style.inset = '0';
  xfade.style.width = '100%';
  xfade.style.height = '100%';
  xfade.style.pointerEvents = 'none';

  stage.appendChild(xfade);

  base.__dtHeroReady = true;
  base.__dtHeroXfade = xfade;
  base.__dtHeroStage = stage;

  // Desktop uses !important, mobile unchanged
  setStyle(base,  'transition', 'none');
  setStyle(base,  'opacity', '1');
  setStyle(xfade, 'transition', 'none');
  setStyle(xfade, 'opacity', '0');

  return { base: base, xfade: xfade, stage: stage };
}


  function crossFadeHero(card, nextAttrs){
  var hero = ensureHeroStage(card);
  if (!hero || !nextAttrs) return Promise.resolve();

  var base  = hero.base;
  var xfade = hero.xfade;

  var nextUrl = bestUrlFromAttrs(nextAttrs);
  if (!nextUrl) {
    applyAttrs(base, nextAttrs);
    return Promise.resolve();
  }

  base.__dtHeroTok = (base.__dtHeroTok || 0) + 1;
  var tok = base.__dtHeroTok;

  var urlOnly = makeUrlAttrs(nextUrl, nextAttrs.alt || base.getAttribute('alt') || '');

  // Desktop uses !important, mobile unchanged
  setStyle(base,  'transition', 'none');
  setStyle(base,  'opacity', '1');

  setStyle(xfade, 'transition', 'none');
  setStyle(xfade, 'opacity', '0');

  return preloadDecode(nextUrl).then(function(){
    if (base.__dtHeroTok !== tok) return;

    applyAttrs(xfade, urlOnly);
    setStyle(xfade, 'opacity', '0');

    return new Promise(function(resolve){
      requestAnimationFrame(function(){
        if (base.__dtHeroTok !== tok) return resolve();

        setStyle(xfade, 'transition', 'opacity ' + HERO_FADE_MS + 'ms ease-in-out');
        setStyle(xfade, 'opacity', '1');

        setTimeout(function(){
          if (base.__dtHeroTok !== tok) return resolve();

          applyAttrs(base, urlOnly);

          setStyle(xfade, 'transition', 'opacity ' + HERO_LAYER_OUT_MS + 'ms ease-out');
          setStyle(xfade, 'opacity', '0');

          setTimeout(function(){
            if (base.__dtHeroTok !== tok) return resolve();
            setStyle(xfade, 'transition', 'none');
            resolve();
          }, HERO_LAYER_OUT_MS + 40);

        }, HERO_FADE_MS + 40);
      });
    });
  });
}


function setHeroInstant(card, attrs){
  var hero = ensureHeroStage(card);
  if (!hero || !attrs) return;

  var url = bestUrlFromAttrs(attrs);
  var urlOnly = makeUrlAttrs(url, attrs.alt || hero.base.getAttribute('alt') || '');

  // Desktop uses !important, mobile unchanged
  setStyle(hero.base,  'transition', 'none');
  setStyle(hero.xfade, 'transition', 'none');
  setStyle(hero.xfade, 'opacity', '0');
  setStyle(hero.base,  'opacity', '1');

  applyAttrs(hero.base, urlOnly);
}


  function buildGroupsFromDom(card){
    var imgs = card.querySelectorAll('.right-container .inner-img img');
    if (!imgs || imgs.length < 8) return null;

    var list = [];
    for (var i=0;i<imgs.length;i++) list.push(imgs[i]);

    var groups = [];
    for (var j=0; j+3 < list.length; j += 4){
      var a0 = readAttrs(list[j]);
      var a1 = readAttrs(list[j+1]);
      var a2 = readAttrs(list[j+2]);
      groups.push({
        views: [
          makeUrlAttrs(bestUrlFromAttrs(a0), a0.alt || ''),
          makeUrlAttrs(bestUrlFromAttrs(a1), a1.alt || ''),
          makeUrlAttrs(bestUrlFromAttrs(a2), a2.alt || '')
        ]
      });
    }
    return (groups.length >= 2) ? groups : null;
  }

  function buildGroupsFromProductJson(card){
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return Promise.resolve(null);

    var href = a.getAttribute('href') || '';
    try { href = new URL(href, window.location.href).pathname; } catch(e){}
    var m = href.match(/\/products\/([^\/\?#]+)/);
    if (!m) return Promise.resolve(null);

    var handle = m[1];

    if (!productGroupsCache.has(handle)){
      productGroupsCache.set(handle,
        fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(data){
            if (!data || !Array.isArray(data.images) || data.images.length < 8) return null;

            var chunks = chunkBy4(data.images);
            if (chunks.length < 2) return null;

            return chunks.map(function(c){
              return {
                views: [
                  makeUrlAttrs(c[0], data.title),
                  makeUrlAttrs(c[1], data.title),
                  makeUrlAttrs(c[2], data.title)
                ]
              };
            });
          })
          .catch(function(){ return null; })
      );
    }

    return productGroupsCache.get(handle);
  }

  // Bubble hero-style crossfade (your code, unchanged)
  function ensureBubbleLayer(bImg){
    if (!bImg) return null;

    if (bImg.__dtBubbleReady) {
      return { base: bImg, xfade: bImg.__dtBubbleXfade, host: bImg.__dtBubbleHost };
    }

    var host = bImg.closest('.right-container .inner-img') || bImg.parentElement;
    if (!host) return null;

    var hs = window.getComputedStyle(host);
    if (hs.position === 'static') host.style.position = 'relative';

    var layer = document.createElement('img');
    layer.className = 'dt-xfade-layer dt-bubble-xfade-layer';
    layer.alt = bImg.getAttribute('alt') || '';
    layer.decoding = 'async';
    layer.loading  = 'eager';

    layer.style.position = 'absolute';
    layer.style.pointerEvents = 'none';
    layer.style.willChange = 'opacity';
    layer.style.zIndex = '999';

    layer.style.inset  = 'auto';
    layer.style.left   = '0px';
    layer.style.top    = '0px';
    layer.style.width  = '0px';
    layer.style.height = '0px';

    layer.style.setProperty('opacity', '0', 'important');
    layer.style.setProperty('transition', 'none', 'important');

    host.appendChild(layer);

    bImg.__dtBubbleReady = true;
    bImg.__dtBubbleHost  = host;
    bImg.__dtBubbleXfade = layer;

    return { base: bImg, xfade: layer, host: host };
  }

  function syncBubbleLayer(bubble){
    var base  = bubble.base;
    var host  = bubble.host;
    var xfade = bubble.xfade;

    var rImg  = base.getBoundingClientRect();
    var rHost = host.getBoundingClientRect();
    if (!rImg.width || !rImg.height) return;

    xfade.style.left   = (rImg.left - rHost.left) + 'px';
    xfade.style.top    = (rImg.top  - rHost.top ) + 'px';
    xfade.style.width  = rImg.width  + 'px';
    xfade.style.height = rImg.height + 'px';

    var cs = window.getComputedStyle(base);
    xfade.style.objectFit = cs.objectFit || 'cover';
    xfade.style.objectPosition = cs.objectPosition || '50% 50%';
    xfade.style.borderRadius = cs.borderRadius || '0px';
    xfade.style.filter = cs.filter || 'none';
    xfade.style.transform = 'none';
  }

  function crossFadeBubbleImg(bImg, nextAttrs){
    if (!bImg || !nextAttrs) return Promise.resolve();

    var bubble = ensureBubbleLayer(bImg);
    if (!bubble) {
      applyAttrs(bImg, nextAttrs);
      return Promise.resolve();
    }

    var nextUrl = bestUrlFromAttrs(nextAttrs);
    if (!nextUrl) {
      applyAttrs(bImg, nextAttrs);
      return Promise.resolve();
    }

    bImg.__dtBubbleTok = (bImg.__dtBubbleTok || 0) + 1;
    var tok = bImg.__dtBubbleTok;

    var urlOnly = makeUrlAttrs(nextUrl, nextAttrs.alt || bImg.getAttribute('alt') || '');

    bubble.xfade.style.setProperty('transition', 'none', 'important');
    bubble.xfade.style.setProperty('opacity', '0', 'important');

    return preloadDecode(nextUrl).then(function(){
      if (bImg.__dtBubbleTok !== tok) return;

      applyAttrs(bubble.xfade, urlOnly);
      syncBubbleLayer(bubble);

      bubble.xfade.offsetHeight;

      return new Promise(function(resolve){
        requestAnimationFrame(function(){
          if (bImg.__dtBubbleTok !== tok) return resolve();

          syncBubbleLayer(bubble);

          bubble.xfade.style.setProperty(
            'transition',
            'opacity ' + BUBBLE_FADE_MS + 'ms ease-in-out',
            'important'
          );
          bubble.xfade.style.setProperty('opacity', '1', 'important');

          setTimeout(function(){
            if (bImg.__dtBubbleTok !== tok) return resolve();

            applyAttrs(bImg, urlOnly);

            bubble.xfade.style.setProperty(
              'transition',
              'opacity ' + BUBBLE_LAYER_OUT_MS + 'ms ease-out',
              'important'
            );
            bubble.xfade.style.setProperty('opacity', '0', 'important');

            setTimeout(function(){
              if (bImg.__dtBubbleTok !== tok) return resolve();
              bubble.xfade.style.setProperty('transition', 'none', 'important');
              resolve();
            }, BUBBLE_LAYER_OUT_MS + 40);

          }, BUBBLE_FADE_MS + 40);
        });
      });
    });
  }

  function render(card, opts){
    opts = opts || {};
    var st = card.__shirtColorSlide;
    if (!st || !st.groups || !st.groups.length) return Promise.resolve();

    var group = st.groups[st.color];
    if (!group || !group.views) return Promise.resolve();

    var wrappers = first3Wrappers(card);
    if (wrappers.length < 3) return Promise.resolve();

    function swapBubblesInstant(){
      for (var i = 0; i < 3; i++){
        var bImg = wrappers[i].querySelector('img');
        if (bImg && group.views[i]) {
          bImg.__dtBubbleTok = (bImg.__dtBubbleTok || 0) + 1;
          if (bImg.__dtBubbleXfade){
            bImg.__dtBubbleXfade.style.transition = 'none';
            bImg.__dtBubbleXfade.style.opacity = '0';
          }
          applyAttrs(bImg, bubbleAttrsFrom(group.views[i], bImg.getAttribute('alt')));
        }
      }
    }

    function fadeBubbles(){
      var ps = [];
      for (var i = 0; i < 3; i++){
        var bImg = wrappers[i].querySelector('img');
        if (bImg && group.views[i]) ps.push(crossFadeBubbleImg(bImg, bubbleAttrsFrom(group.views[i], bImg.getAttribute('alt'))));

      }
      return Promise.all(ps);
    }

    setActiveView(card, wrappers, st.view);

    if (opts.instant || opts.manual){
      if (card.__bubbleDelayTimer) clearTimeout(card.__bubbleDelayTimer);
      swapBubblesInstant();
      setHeroInstant(card, heroAttrsFrom(group.views[st.view]));
      return Promise.resolve();
    }

    if (card.__bubbleDelayTimer) clearTimeout(card.__bubbleDelayTimer);
    card.__bubbleDelayTimer = setTimeout(function(){
      fadeBubbles();
    }, BUBBLE_SWAP_DELAY_MS);

    return crossFadeHero(card, heroAttrsFrom(group.views[st.view]));

  }

  function stepColor(card){
    var st = card.__shirtColorSlide;
    if (!st || !st.groups) return;
    st.color = (st.color + 1) % st.groups.length;
    render(card, { instant:false, manual:false });
  }

  function attachShirtCard(card){
    if (card.__shirtColorSlideAttached) return;
    card.__shirtColorSlideAttached = true;

    var wrappers = first3Wrappers(card);
    if (wrappers.length < 3) return;

    var active = card.querySelector('.right-container .inner-img.is-active');
    var viewIdx = active ? wrappers.indexOf(active) : 0;
    if (viewIdx < 0) viewIdx = 0;

    function pause(){
      card.__shirtColorPausedUntil = Date.now() + PAUSE_AFTER_TOUCH_MS;
    }

    // Bubble click = manual view select (NO crossfade)
    card.addEventListener('click', function(e){
      var w = e.target.closest('.right-container .inner-img');
      if (!w || !card.contains(w)) return;

      var idx = wrappers.indexOf(w);
      if (idx < 0 || idx > 2) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      pause();
      if (card.__shirtColorSlide) card.__shirtColorSlide.view = idx;

      render(card, { manual:true, instant:true });

      requestAnimationFrame(function(){
        var ae = document.activeElement;
        if (ae && typeof ae.blur === 'function') ae.blur();
      });
    }, true);

    function start(){
      if (!card.__shirtColorSlide || !card.__shirtColorSlide.groups) return;

      if (card.__shirtColorTimer) clearInterval(card.__shirtColorTimer);

      render(card, { instant:true });

      card.__shirtColorTimer = setInterval(function(){
        if (Date.now() < card.__shirtColorPausedUntil) return;
        stepColor(card);
      }, INTERVAL_MS);
    }

    function stop(){
      if (card.__shirtColorTimer){
        clearInterval(card.__shirtColorTimer);
        card.__shirtColorTimer = null;
      }
    }

    var groups = buildGroupsFromDom(card);
    var ready = groups ? Promise.resolve(groups) : buildGroupsFromProductJson(card);

    ready.then(function(g){
      if (!g || g.length < 2) return;

      card.__shirtColorSlide = { groups: g, color: 0, view: viewIdx };
      card.__shirtColorPausedUntil = 0;

      ensureHeroStage(card);
      render(card, { instant:true });

      // viewport-based observer (recommendations is vertical; no rail root)
      if ('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if (entry.isIntersecting && entry.intersectionRatio >= 0.45) start();
            else stop();
          });
        }, { threshold: [0, 0.45, 0.8] });
        io.observe(card);
      } else {
        start();
      }
    });
  }

  function initShirtsRotate(SCOPE){
    if (!SCOPE || !SCOPE.querySelectorAll) return;
    $all(SCOPE, '.slide-item.is-shirt').forEach(attachShirtCard);
  }

  // ------------------------------------------------------------
  // Master init (recommendations scope)
  // ------------------------------------------------------------
  function init(root){
    var R = isEl(root) ? root : document;
    var scopes = [];

    if (isEl(R) && R.matches && R.matches('.product-recommendations[data-reco-deck="1"]')){
      scopes = [R];
    } else if (R.querySelectorAll){
      scopes = $all(R, '.product-recommendations[data-reco-deck="1"]');
    }

    // If caller passed container that contains the wrapper, keep it workable
    if (!scopes.length && isEl(R)) scopes = [R];

    scopes.forEach(function(S){
      initCanvasJournalsBubbles(S);
      initWavesParallax(S);
      initShirtsRotate(S);
    });
  }

  // Expose for AJAX remount
  window.SFDeckTabsInit = init;

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ init(document); });
  } else {
    init(document);
  }

  // Theme editor section reload
  document.addEventListener('shopify:section:load', function(e){
    init(e && e.target ? e.target : document);
  });
})();

  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------  // ------------------------------------------------------------
  // (C) Shirts rotate + crossfade (your 3rd script, bound to .is-shirt cards)
  // ------------------------------------------------------------




/* =========================================================
   SF — Bubble Clickability Patch (Recommendations)
   - Fixes bubbles not selectable due to link overlays / layers
   - Scopes only to .product-recommendations[data-reco-deck="1"]
   ========================================================= */
(function () {
  'use strict';

  var PATCHED = new WeakSet();
  var LISTENER_ADDED = false;

  function isEl(n){ return !!(n && n.nodeType === 1); }

  function getScopes(root){
    var R = isEl(root) ? root : document;
    if (isEl(R) && R.matches && R.matches('.product-recommendations[data-reco-deck="1"]')) return [R];
    if (R.querySelectorAll) return Array.prototype.slice.call(
      R.querySelectorAll('.product-recommendations[data-reco-deck="1"]')
    );
    return [];
  }

  function patchOneScope(scope){
    if (!isEl(scope) || PATCHED.has(scope)) return;
    PATCHED.add(scope);

    // Lift bubble area above any “card link overlay”
    scope.querySelectorAll('.slide-item').forEach(function(card){
      // Bubble wrapper
      var right = card.querySelector('.right-container');
      if (right) {
        if (getComputedStyle(right).position === 'static') right.style.position = 'relative';
        right.style.zIndex = '50';
        right.style.pointerEvents = 'auto';
      }

      // Individual bubbles
      card.querySelectorAll('.right-container .inner-img').forEach(function(w){
        if (getComputedStyle(w).position === 'static') w.style.position = 'relative';
        w.style.zIndex = '60';
        w.style.pointerEvents = 'auto';
      });

      // Bubble images should accept clicks (theme sometimes sets pointer-events none)
      card.querySelectorAll('.right-container .inner-img img').forEach(function(img){
        img.style.pointerEvents = 'auto';
      });

      // Your crossfade overlay should never intercept clicks
      card.querySelectorAll('.dt-bubble-xfade-layer').forEach(function(layer){
        layer.style.pointerEvents = 'none';
      });

      // If there is a full-card overlay link as a direct child, keep it behind bubbles.
      // (This preserves card click navigation everywhere except bubble taps.)
      card.querySelectorAll(':scope > a').forEach(function(a){
        var cs = getComputedStyle(a);
        if (cs.position === 'absolute') {
          a.style.zIndex = '1';
        }
      });
    });
  }

  function patch(root){
    getScopes(root).forEach(patchOneScope);
  }

  function addGlobalGuard(){
  if (LISTENER_ADDED) return;
  LISTENER_ADDED = true;

  // Run in BUBBLING phase so your deck-tabs handlers (capture=true) run first.
  document.addEventListener('click', function(e){
    var bubble = e.target.closest('.product-recommendations[data-reco-deck="1"] .right-container .inner-img');
    if (!bubble) return;

    // Only block navigation if a link is involved.
    var a = e.target.closest('a');
    if (a) e.preventDefault();

    // Stop the click from bubbling up to any card-level navigation handler.
    e.stopPropagation();
    // DO NOT stopImmediatePropagation here.
  }, false);

  document.addEventListener('pointerdown', function(e){
    var bubble = e.target.closest('.product-recommendations[data-reco-deck="1"] .right-container .inner-img');
    if (!bubble) return;

    var a = e.target.closest('a');
    if (a) e.preventDefault();

    e.stopPropagation();
  }, false);
}


  // Wrap existing init so patch always runs after your normal init
  var origInit = window.SFDeckTabsInit;
  window.SFDeckTabsInit = function(root){
    if (typeof origInit === 'function') origInit(root);
    addGlobalGuard();
    patch(root || document);
  };

  // Initial load + theme editor reload
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      addGlobalGuard();
      patch(document);
    });
  } else {
    addGlobalGuard();
    patch(document);
  }

  document.addEventListener('shopify:section:load', function(e){
    addGlobalGuard();
    patch(e && e.target ? e.target : document);
  });

})();


/* =========================================================
   SF — Product Recommendations Mobile Controller
   - Bubble taps: always work on real mobile (even with overlay link on top)
   - Ghost click: suppressed so bubbles never navigate
   - Navigation: HERO ONLY (tap hero navigates to product)
   Scope: .product-recommendations[data-reco-deck="1"]
   ========================================================= */
(function () {
  'use strict';

  var suppressUntilByCard = new WeakMap();
  var boundScopes = new WeakSet();

  // Change this if you ever want "card" instead of "hero"
  var NAV_MODE = 'hero'; // 'hero' | 'card'

  function isMobileCoarse() {
    return window.matchMedia && window.matchMedia('(pointer: coarse), (max-width: 989px)').matches;
  }

  function inRect(x, y, r) {
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  function dispatchClick(el) {
    if (!el) return;
    el.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));
  }

  function findProductHref(card) {
    // Prefer the overlay link if present, otherwise any product link in the card
    var a =
      card.querySelector('a.listing-link[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href') : null;
  }

  function findHeroZone(card) {
    return (
      card.querySelector('#top-left') ||
      card.querySelector('.top-left') ||
      card.querySelector('.listing-top') ||
      null
    );
  }

  function isInBubbles(target) {
    return !!(target && target.closest && target.closest('.right-container .inner-img'));
  }

  function patchOverlayLink(card) {
    // We disable the overlay link so it cannot steal taps on mobile,
    // then we provide explicit navigation behavior ourselves.
    var a = card.querySelector('a.listing-link');
    if (!a) return;
    a.style.pointerEvents = 'none';
  }

  function bindScope(scope) {
    if (!scope || boundScopes.has(scope)) return;
    boundScopes.add(scope);

    // Disable overlay link hit-targets inside this scope (mobile only)
    if (isMobileCoarse()) {
      scope.querySelectorAll('.slide-item').forEach(patchOverlayLink);
    }

    // 1) Kill the "ghost click" that iOS/Android fires after touch,
    // but only for a short window after a bubble tap.
    scope.addEventListener('click', function (e) {
      if (!e.isTrusted) return;        // allow synthetic click we dispatch for bubbles
      if (!isMobileCoarse()) return;

      var card = e.target && e.target.closest ? e.target.closest('.slide-item') : null;
      if (!card || !scope.contains(card)) return;

      var until = suppressUntilByCard.get(card) || 0;
      if (Date.now() < until) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }
    }, true);

    // 2) Coordinate-based bubble tap (works even when overlay is on top)
    function bubbleTapHandler(e) {
      if (!isMobileCoarse()) return;

      // Avoid double-fire on devices supporting PointerEvent
      if (e.type === 'touchstart' && window.PointerEvent) return;

      var x, y;
      if (e.touches && e.touches.length) {
        x = e.touches[0].clientX; y = e.touches[0].clientY;
      } else if (typeof e.clientX === 'number') {
        x = e.clientX; y = e.clientY;
      } else {
        return;
      }

      // Find the bubble rect containing the tap
      var bubbles = scope.querySelectorAll('.right-container .inner-img');
      var hit = null;
      for (var i = 0; i < bubbles.length; i++) {
        var r = bubbles[i].getBoundingClientRect();
        if (r.width && r.height && inRect(x, y, r)) { hit = bubbles[i]; break; }
      }
      if (!hit) return;

      var card = hit.closest('.slide-item');
      if (!card) return;

      // Block the overlay link touch sequence immediately
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      // Suppress the next trusted click so it won't navigate
      suppressUntilByCard.set(card, Date.now() + 900);

      // Trigger your existing bubble click logic
      dispatchClick(hit.querySelector('img') || hit);
    }

    scope.addEventListener('touchstart', bubbleTapHandler, { capture: true, passive: false });
    scope.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
      bubbleTapHandler(e);
    }, { capture: true });

    // 3) Provide explicit navigation (hero-only by default)
    scope.addEventListener('pointerup', function (e) {
      if (!isMobileCoarse()) return;
      if (!e.isTrusted) return;

      var card = e.target && e.target.closest ? e.target.closest('.slide-item') : null;
      if (!card || !scope.contains(card)) return;

      // Never navigate from bubble interactions
      if (isInBubbles(e.target)) return;

      // If we just tapped a bubble, do not navigate
      var until = suppressUntilByCard.get(card) || 0;
      if (Date.now() < until) return;

      var href = findProductHref(card);
      if (!href) return;

      if (NAV_MODE === 'hero') {
        var hero = findHeroZone(card);
        if (!hero) return;
        // Only navigate when the pointerup is inside hero’s bounding box
        var rect = hero.getBoundingClientRect();
        if (!inRect(e.clientX, e.clientY, rect)) return;
      }

      window.location.href = href;
    }, { passive: true });
  }

  function init(root) {
    var R = (root && root.querySelectorAll) ? root : document;
    R.querySelectorAll('.product-recommendations[data-reco-deck="1"]').forEach(bindScope);
  }

  // Ensure it runs after your deck-tabs init + after AJAX injection
  var origInit = window.SFDeckTabsInit;
  window.SFDeckTabsInit = function (root) {
    if (typeof origInit === 'function') origInit(root);
    init(root || document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e && e.target ? e.target : document);
  });

  // In case recommendations cards are replaced dynamically
  window.addEventListener('resize', function () { init(document); }, { passive: true });
})();

